module.exports = __webpack_public_path__ + "media/images/institutional2-cfddbb3970ac9e575e77e031d894eec6.png";